export default __webpack_public_path__ + "static/media/cuff.7d993240.webp";